import { get, del, post, put, postJson} from '../axios'

const api = {
    customConfig: params => get('/member/titleConf', params),          //全局配置
    getKeyBoard: params => get('/payment/keyPad', params),   //获取软键盘key
    loginAdvance: params => get('/member/securities', params),          //预登录
    login: params => post('/member/login', params),              // 登录退出
    logout: params => del('/member/token', params),
    userinfo: params => post('/oauth/userinfo', params),    //获取用户信息
    getToken: params => post('/member/token', params), //获取token
    refreshToken: params => put('/member/token', params), //获取token
    verifyToken: params => post('/member/token-check', params), //验证token
    userInfo: params => get('/cust/custMembers/photo', params),//获取用户信息
    //忘记密码
    accountVerify: params => post('/cust/custMembers/memberExist', params),//验证账号是否存在
    questionAvoid: params => get('/cust/memberQuestions', params),//获取已设置安全问题
    verifyForPW: params => post('/cust/memberQuestions/verifyForPW', params),//验证安全问题
    retrievePassword: params => post('/cust/custMembers/findOutPW', params),//找回密码
    //充值
    //充值
    rechargeOrders: params => post('/payment/rechargeOrders', params), //充值下单
    charge: params => post('/payment/recharges', params), //充值
    ordersStatus: params => get('/payment/orders', params), //充值订单状态查询
    //账单页面
    bill: params => get('/accounting/bizs/list', params), //账单查询
    //我的
    //支付顺序
    paySort : params => get('/accounting/PayOrders', params),
    payPut : (params,urlParams) => put('/accounting/PayOrders/'+urlParams, params),//修改支付顺序
    //密码设置
    changePasswordLogin : params => post('/cust/custMembers/modifyPW', params),//修改登录密码
    changePasswordPay : params => post('', params),//修改支付密码
    //安全问题
    question: params => get('/cust/memberQuestions', params),//获取已设置安全问题，为空代表没设置
    questionAll: params => get('/cust/questions', params),//获取全部安全问题
    questionVerify: params => post('/cust/memberQuestions/verify', params),//验证安全问题
    questionSet: params => post('/cust/memberQuestions', params),//设置安全问题
    //银行卡
    bankCard: params => get('/payment/bankCardRelations', params),//已绑定银行卡
    bankBind: params => post('/payment/bankCardRelations', params),//绑定银行卡
    bankUnbind: params => del('/payment/bankCardRelations', params),//解绑
    //交易限额
    electronicAccount: params => get('/accounting/accounts', params),//获取电子账户
    electronicAccountEdit: (params,urlParams) => put('/accounting/accounts/limit/'+urlParams, params),//修改
    //充值设置
    chargeSet: params => get('/accounting/accounts', params),//充值设置列表
    chargeEdit: (params,urlParams) => put('/accounting/accounts/recharge/'+urlParams, params),//修改
    chargePayType: (params,urlParams) => put('/accounting/accounts/bank/'+urlParams, params),//设置自动扣款充值账户
    chargeGetPayType: params => get('/accounting/accounts/bank', params),//查询可选择和已设置扣款账户
    //免密签约
    avoidClose: params => get('/payment/agreements', params),//免密签约
    signing: params => post('/payment/agreements', params),//签约
    termination: params => del('/payment/agreements', params),//解约
    //支付页面
    payOrder: (params,urlParams) => get('/payment/prepayOrders/'+urlParams, params), //查询支付订单信息
    bindOrder:(params,urlParams) => post(`/payment/prepayOrders/${urlParams}/apply`, params),//订单与人员绑定
    payStatus:(params,urlParams) => get(`/payment/prepayOrders/${urlParams}/status`, params),//轮询支付状态
    payType:params => get('/payment/paySequences', params),//获取支付方式
    pay:(params,urlParams) => post('/payment/orders/'+urlParams+'/pay', params),//确认支付
    gatewayPay:(params,urlParams) => post('/payment/orders/'+urlParams+'/gatewayPay', params),//网关支付
    payJump:(params,urlParams) => get('/payment/prepayOrders/'+urlParams+'/jump', params),//支付成功后跳转
    changePayStatus:params => put('/payment/orders/cancelPay', params),//微信取消支付后，改变订单状态
    closed:params => put('/payment/orders/closed', params),//关闭订单
    //获取密钥
    keyPad:params => get('/payment/keyPad', params),//获取密钥

    //短信支付
    getMobile:(params,urlParams) => postJson('/payment/orders/'+urlParams+'/getMobileNo?method=member', params),//获取手机号
    sendSms:(params,urlParams) => postJson('/payment/orders/'+urlParams+'/sendSms?method=member', params),//发送验证码
    smsPay:(params,urlParams) => postJson('/payment/orders/'+urlParams+'/payWithSms?method=member', params),//短信支付
};
export default api